import { render, staticRenderFns } from "./GalleryDashboardSection.vue?vue&type=template&id=4ba80082&scoped=true"
import script from "./GalleryDashboardSection.vue?vue&type=script&lang=ts"
export * from "./GalleryDashboardSection.vue?vue&type=script&lang=ts"
import style0 from "./GalleryDashboardSection.vue?vue&type=style&index=0&id=4ba80082&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba80082",
  null
  
)

export default component.exports